/**
 * Menu script
 */
class ATS_planeAnimation {
    constructor() {
        ATS_planeAnimation.initPlaneMove();
    }

    static initPlaneMove ()  {
        let planeWrapper = document.querySelector('.plane-wrapper');

        if (planeWrapper) {
            var planeImg = document.querySelector('.plane');
            var finish = document.querySelector('.plane-line');
            var currentScroll = window.pageYOffset;
            var lastScrollTop = 0;
            var planeTop = planeWrapper.getBoundingClientRect().top + currentScroll;
            var finishBottom = finish.getBoundingClientRect().top + finish.getBoundingClientRect().height + currentScroll;
            window.addEventListener('scroll', calculatePlane);
            window.addEventListener('resize', recalculateOnResize);
            window.addEventListener('load', function () {
                recalculateOnResize();
            });

            function calculatePlane() {
                currentScroll = window.pageYOffset;
                var triggerPoint = currentScroll + window.innerHeight / 2 - planeWrapper.offsetHeight / 2 - 50;

                if (triggerPoint - planeTop > 0 && triggerPoint - planeTop <= finishBottom - planeTop - planeWrapper.offsetHeight / 2) {

                    if (currentScroll > lastScrollTop) {
                        planeWrapper.style.transform = 'translateY(' + (triggerPoint - planeTop) + 'px) translateX(-50%) rotate(0)';
                    } else {
                        planeWrapper.style.transform = 'translateY(' + (triggerPoint - planeTop) + 'px) translateX(-50%) rotate(180deg)';
                    }

                    lastScrollTop = currentScroll;

                    if (!planeImg.classList.contains('is-animated')) {
                        planeImg.classList.add('is-animated');
                    }

                    return;
                }
            }

            function recalculateOnResize() {
                var planeTransformRaw = planeWrapper.style.transform;
            
                if (planeTransformRaw) {
                    planeTransformRaw = planeTransformRaw.split(' ').filter(function (v) {
                    return v.indexOf('translateY') > -1;
                }).map(function (v) {
                    return v.replace(/[^0-9-.]/gmi, '');
                });
                planeTransformRaw = parseInt(planeTransformRaw, 10);
                }
            
                currentScroll = window.pageYOffset;
                planeTop = planeWrapper.getBoundingClientRect().top + currentScroll - planeTransformRaw;
                finishBottom = finish.getBoundingClientRect().top + finish.getBoundingClientRect().height + currentScroll;
                calculatePlane();
            }
        }
    }
}